
import { Engine } from 'json-rules-engine';
import { init as initFacts } from './facts-impl';


export const runRule = async (fegoRule, context) => {
    const { items = [] } = fegoRule?.[0] || {};
    const engine = new Engine();
    const facts = initFacts();
    //添加一个全局的fact，用于存储一些全局的变量，比如当前变量，当前上下文，当前配置等
    engine.addFact('__FEGO_RUNTIME__', {
        context,
        config: fegoRule,
    });

    items.forEach((item) => {
        engine.addRule(item);
    });

    const res = await engine.run(facts);

    //生成返回格式，格式以 id: {result, params} 的形式返回
    const results = {};
    res.results.forEach((item) => {
        results[item.event.params.id] = {
            eventName: item.name,
            result: item.result,
            params: item.event.params,
        };
    });

    res.failureResults.forEach((item) => {
        results[item.event.params.id] = {
            eventName: item.name,
            result: item.result,
            params: item.event.params,
        };
    });

    console.log('[fego-condition][runRule]results', results, res);
    return results;
};


